<template>
    <header>
        <router-link :to="{name: 'home-with-lang', params:{ lang }}" class="btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 65"><path fill-rule="evenodd" d="M55.07 61.72c-.26 1.11-5.36 4.04-12.45 1.77-3.32-1.07-1.21-11.6-2.7-13.5-1.16-1.48-11.14-3.17-14.39.1-2.03 2.04.06 12.43-4.3 13.7-6.45 1.87-7.8.24-8.79-.05-1.89-.54-4.05-.8-3.86-12.14.18-11.3 1.3-19.76 1.3-19.76s-4.36 3.08-7.34 2.54c-2.97-.54-4.34-2.61 1.6-12.33C10.09 12.31 30.62-1.94 34.41.22c5.21 2.97 15.44 8.87 25.27 22.58 4.65 6.48 6.39 14.69-1.81 11.02-3.74-1.68-3.64-1.96-3.64-1.96s2.22 24.04.84 29.87v-.01Z" clip-rule="evenodd"/></svg>
            <span class="sr-only">Accueil</span>
        </router-link>
    </header>

    <div id="music-list" class="page-box">
        <h1 class="page-box-title">{{ copydeck.playlist.title[lang] }}</h1>

        <Tabs>

            <Tab :title="copydeck.emotions.calm[lang]">
                <TabPlaylist
                    :songs="calmSongs"
                    :lang="lang"
                    @play="onPlay"
                    @stop="onStop"
                />
            </Tab>

            <Tab :title="copydeck.emotions.fear[lang]">
                <TabPlaylist
                    :songs="fearSongs"
                    :lang="lang"
                    @play="onPlay"
                    @stop="onStop"
                />
            </Tab>

            <Tab :title="copydeck.emotions.sadness[lang]">
                <TabPlaylist
                    :songs="sadnessSongs"
                    :lang="lang"
                    @play="onPlay"
                    @stop="onStop"
                />
            </Tab>

            <Tab :title="copydeck.emotions.joy[lang]">
                <TabPlaylist
                    :songs="joySongs"
                    :lang="lang"
                    @play="onPlay"
                    @stop="onStop"

                />
            </Tab>


        </Tabs>
    </div>

    <nav class="nav-prevnext">
        <router-link :to="previousPage" class="btn-icon prev">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 52"><path fill-rule="evenodd" d="M62.27 37.466c1.86-.44 3.28-2.89 2.52-9-.76-6.11.05-11.24-.49-13.15-.55-1.91-1.07-3.63-12.26-1.18s-19.96 4.95-19.96 4.95 3.11-13.5 2.56-16.5c-.55-3-2.63-4.38-12.46 1.62-9.82 6-24.22 20.38-22.04 24.2 3.001 5.27 8.95 10.14 22.8 20.07 6.55 4.7 11.95 5.27 11.13-1.82-.82-7.09-1.98-12.77-1.98-12.77s24.29 4.97 30.17 3.57l.01.01Z" clip-rule="evenodd"/></svg>
        </router-link>
    </nav>
</template>

<script>
    import Tabs from "../components/Tabs.vue";
    import Tab from "../components/Tab.vue";
    import Card from "../components/Card.vue";
    import SoundButton from "../components/SoundButton.vue";

    export default {
        name: "Music",
        components: { Tabs, Tab, Card,SoundButton }
    }
</script>

<script setup>

    import { computed, ref } from "vue";

    import { useRouter } from "vue-router";
    import { useMainStore }     from "../stores/main.js";
    import { storeToRefs }        from "pinia";
    import TabPlaylist from "../components/TabPlaylist.vue";

    const router = useRouter();
    let store = useMainStore();
    const { lang, songs, copydeck } = storeToRefs(store);

    let { getPreviousPage } = store;
    let previousPage = computed ( () => getPreviousPage());


    const calmSongs = computed ( () => songs.value.filter(song => song.emotion === "calm").sort ( (a,b) => a.id - b.id));
    const fearSongs = computed ( () => songs.value.filter(song => song.emotion === "fear").sort ( (a,b) => a.id - b.id));
    const sadnessSongs = computed ( () => songs.value.filter(song => song.emotion === "sadness").sort ( (a,b) => a.id - b.id));
    const joySongs = computed ( () => songs.value.filter(song => song.emotion === "joy").sort ( (a,b) => a.id - b.id));

    const soundButtonCallback = ref(null);
    function onPlay (callback)
    {
        if (soundButtonCallback.value)
        {
            soundButtonCallback.value();
        }

        soundButtonCallback.value = callback;
    }

    function onStop ()
    {
        if (soundButtonCallback.value)
        {
            soundButtonCallback.value = null;
        }
    }

</script>
